import React, { useEffect, useRef, useState } from 'react';
import Container from 'react-bootstrap/Container';
import Nav from 'react-bootstrap/Nav';
import Navbar from 'react-bootstrap/Navbar';
import NavDropdown from 'react-bootstrap/NavDropdown';
import { Button } from 'react-bootstrap';
import { Link, NavLink, useLocation } from 'react-router-dom';
import { FaRegUserCircle, FaSearch, FaShoppingCart } from 'react-icons/fa';
import Modal from 'react-bootstrap/Modal';
import { RiDraftLine } from 'react-icons/ri';
import { VscGitPullRequestDraft } from 'react-icons/vsc';
import axios from 'axios';

export const Topbar = () => {
  const [show, setShow] = useState(false);
  const [showDropdown, setShowDropdown] = useState(false);
  const dropdownRef = useRef(null);

  const handleClose = () => setShow(false);
  const handleShow = () => setShow(true);

  // Check if user is logged in
  const isLoggedIn = sessionStorage.getItem("userId") !== null;
  const randomId = sessionStorage.getItem("randomUserId");
  const userToken = sessionStorage.getItem("userToken");
  const userId = sessionStorage.getItem("userId");
  const [profile, setProfile] = useState([]);

  const handleLogout = () => {
    // Clear all session data
    sessionStorage.removeItem("userId");
    sessionStorage.removeItem("randomUserId");
    // Redirect to home page or any other desired route
    window.location.href = "/";
  };
  const location = useLocation();
  const currentPath = location.pathname;

useEffect(() => {
    const fetchData = async () => {
      try {
        // Get token from local storage
        const token = userToken;

        // Make API request with token
        const response = await axios.get(
          `https://ecom.testingwebsitelink.com/api/get-profile/${userId}`,
          {
            headers: {
              Authorization: `Bearer ${token}`,
            },
          }
        );
        console.log("databymmm", response.data);
        // Set the fetched data to the state
        setProfile(response.data.data);
      } catch (error) {
        console.error("Error fetching data:", error);
      }
    };

    // Call the fetchData function
    fetchData();
    // getOrderSummary();
  }, []); // Empty dependency array ensures this effect runs only once

 // Handle clicks outside the dropdown
 useEffect(() => {
  function handleClickOutside(event) {
    if (dropdownRef.current && !dropdownRef.current.contains(event.target)) {
      setShowDropdown(false);
    }
  }

  if (showDropdown) {
    document.addEventListener("mousedown", handleClickOutside);
  }
  return () => {
    document.removeEventListener("mousedown", handleClickOutside);
  };
}, [showDropdown]);
  return (
    <>
      <Navbar collapseOnSelect expand="lg">
        <Container className='topbarContainer'>
          <Navbar.Brand>
            <NavLink to="/"><img width={210} src={require("../assets/logo/logo.png")} alt="Google" /></NavLink>
          </Navbar.Brand>
          <Navbar.Toggle aria-controls="responsive-navbar-nav" />
          <Navbar.Collapse id="responsive-navbar-nav" style={{ justifyContent: "space-around" }}>
            <Nav className='menunav'>
              {(() => {
                if (randomId) {
                  return <NavLink to="/login" className="nav-link sub" >Subscription</NavLink>;
                } else if(isLoggedIn) {
                  return <NavLink to="/subscription" className={currentPath === "subscription" ? "nav-link active" : "nav-link"}>Subscription</NavLink>;
                } else{
                  return <Link to="/login" className="nav-link sub">Subscription</Link>;
                }
              })()}
              
              <NavLink to="/about-us" className={currentPath === "about-us" ? "nav-link active" : "nav-link"}>About Us</NavLink>
              <NavLink to="/supporting-veterans" className={currentPath === "supporting-veterans" ? "nav-link active" : "nav-link"}>Supporting Veterans</NavLink>
              <NavLink to="/contact-us" className={currentPath === "contact-us" ? "nav-link active" : "nav-link"}>Contact Us</NavLink>
            </Nav>
            <Nav className='secondMenu'>
              <div className='menuicons'>
                {/* <FaSearch /> */}
                <Link to='/checkout'><FaShoppingCart /></Link>
                {isLoggedIn ? (
                <>
                <Link to={`/all-draft/${userId}`}><VscGitPullRequestDraft/></Link>
                <div className="profile-dropdown" ref={dropdownRef}>
                  {profile.image == null ? <FaRegUserCircle onClick={() => setShowDropdown(!showDropdown)} /> :
                  <img src={profile.image} alt="profile" className="profile-image" onClick={() => setShowDropdown(!showDropdown)} />}
                  {/* <img src={profile.image || "https://via.placeholder.com/40"} alt="profile" className="profile-image" onClick={() => setShowDropdown(!showDropdown)} /> */}
                  {/* <img
                    src={profile.image || "https://via.placeholder.com/40"}
                    alt="profile"
                    className="profile-image"
                    onClick={() => setShowDropdown(!showDropdown)}
                  /> */}
                  {showDropdown && (
                     <div className="dropdown-menu1">
                     <Link to="/profile" className="dropdown-item1" onClick={() => setShowDropdown(false)}>Profile</Link>
                     <Link to="/change-password" className="dropdown-item1" onClick={() => setShowDropdown(false)}>Change Password</Link>
                     <button className="dropdown-item1 logout" onClick={handleLogout}>Logout</button>
                   </div>
                  )}
                </div>
                </>
                ) : (
                  <NavLink to="/login" className="nav-link header-icon" activeClassName="active">
                    <FaRegUserCircle />
                  </NavLink>
                )}
              </div>
            </Nav>
          </Navbar.Collapse>
        </Container>
        <style jsx>{`
        .profile-dropdown {
          position: relative;
          display: inline-block;
        }

        .profile-image {
          width: 40px;
          height: 40px;
          border-radius: 50%;
          cursor: pointer;
          object-fit: cover;
        }

        .dropdown-menu1 {
          position: absolute;
          top: 50px;
          right: 0;
          background: white;
          border: 1px solid #ccc;
          border-radius: 5px;
          box-shadow: 0px 4px 6px rgba(0, 0, 0, 0.1);
          min-width: 150px;
          z-index: 1000;
        }

        .dropdown-item1 {
          padding: 10px;
          text-align: left;
          display: block;
          color: black;
          text-decoration: none;
          transition: background 0.3s;
        }

        .dropdown-item1:hover {
          background: #f0f0f0;
        }

        .logout {
          border: none;
          background: none;
          width: 100%;
          text-align: left;
          cursor: pointer;
          color: red;
        }
      `}</style>
      </Navbar>
    </>
  );
};
